<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import CommentButton from '@/components/modules/CTA/CommentButton'
  import LikeButton from '@/components/modules/CTA/LikeButton'

  export default {
    name: 'CTA',
    components: {
      CommentButton,
      LikeButton,
    },
    props: {
      id: String,
      hash: String,
      likes: Object,
      comments: Object,
      openedPanel: String,
      commentsActive: Boolean,
      likesActive: Boolean,
    },
    methods: {
      onLike(val) {
        this.$emit('onLike', val)
      },
      onComment(val) {
        this.$emit('onComment', val)
      },
      onTogglePanel(val) {
        this.$emit('onTogglePanel', val)
      },
      onDeleteComment(selectedCommentId, postId) {
        this.$emit('onDeleteComment', selectedCommentId, postId)
      },
    },
  }
</script>
